import { UNE_PASSWORD_POLICY, type PasswordPolicy } from '@/lib/passwordRules';

/**
 * Policy de contraseña de la app de Une Crédito. **FIJA** — ya no consulta
 * `GET /public/password-policy`, que devuelve la policy global del lambda RBAC y no la del pool
 * de `une`. El porqué completo está en `@/lib/passwordRules`.
 */
export function usePasswordPolicy(): PasswordPolicy {
  return UNE_PASSWORD_POLICY;
}
